// /src/hooks/api/useChat.js
import { useMutation } from "@tanstack/react-query";
import { chatImage } from "api/chat";

export const useChatImage = (options = {}) =>
  useMutation({
    mutationFn: chatImage,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
  });
